import React from 'react';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select, {SelectProps} from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';

import {createStyles, withStyles, Theme} from '@components/@theme';

export interface SingleSelectProps extends SelectProps {
  width?: number | string;
}

export const SingleSelect = props => {
  const labelId = `${props.name || props?.label?.replace(' ', '-') || 'unknown'}-select-label`;
  return (
    <FormControl>
      <InputLabel id={labelId}>{props.label}</InputLabel>
      <Select
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: {vertical: 'bottom', horizontal: 'left'},
        }}
        labelId={labelId}
        // @ts-ignore TODO figure out where this error came from
        input={<BootstrapInput />}
        label={props.label}
        {...props}
      />
    </FormControl>
  );
};

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: `1px solid rgba(0, 0, 0, 0.23)`,
      fontSize: 14,
      padding: '6.7px 26px 6.7px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        backgroundColor: theme.palette.background.paper,
        borderRadius: 4,
        boxShadow: 'inset 0 1px 4px rgb(0 0 0 / 20%)',
      },
    },
  })
)(InputBase);
